var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.455 2.102V.908h-4.91v1.194H1.639v2.394h20.722V2.102zM3.953 23.092h16.094l1.287-17.686H2.666z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMzMzMzMyIgPgo8Zz4KCTxwb2x5Z29uIHBvaW50cz0iMTQuNDU1LDIuMTAyIDE0LjQ1NSwwLjkwOCA5LjU0NSwwLjkwOCA5LjU0NSwyLjEwMiAxLjYzOSwyLjEwMiAxLjYzOSw0LjQ5NiAyMi4zNjEsNC40OTYgMjIuMzYxLDIuMTAyICIvPgoJPHBvbHlnb24gcG9pbnRzPSIzLjk1MywyMy4wOTIgMjAuMDQ3LDIzLjA5MiAyMS4zMzQsNS40MDYgMi42NjYsNS40MDYgCSIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgDelete as ReactComponent };